(function($) {
    "use strict";

    // Return if not proper template
    if ( !$('body').hasClass('page-template-hub-resources') ) return;

    $(function() {

        var resourcesString = '';

        var resourceKeywords = $('.resources-page-filter-input input');

        resourceKeywords.on('input', function( event ) {
            updateURIParameterByName( 'search', event.target.value );
        });

        var resourceType = $('select.hub-page-filter-type').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        resourceType.on( 'select2:select', function( event ) {
            var value = resourceType.val();
            updateURIParameterByName( 'type', value );
        });

        var resourceIssue = $('select.hub-page-filter-issue').select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: true,
            dropdownCssClass: "dark-dropdown"
        });

        resourceIssue.on( 'select2:select', function( event ) {
            var value = resourceIssue.val();
            updateURIParameterByName( 'issue', value );
        });

        $( '.hub-page-resources__filter a' ).click( function( event ) {
            event.preventDefault();
            var clickedLink = $( this ),
                href = clickedLink.attr( 'href' );

            window.location.href = href + resourcesString;
        });

        // Spaces to plus signs
        function encodeSpacesToPlus( string ) {
            if ( string === null ) return null;
            return string.split( ' ' ).join( '+' );
        };

        // Update URI vars
        var updateURIParameterByName = function( name, value ) {
            var re = new RegExp("([#&])" + name + "=.*?(&|$)", "i"),
                separator = resourcesString.indexOf('#') !== -1 ? "&" : "#",
                updatedURL = '';
            if ( value === null ) value = '';
            if (resourcesString.match(re)) {
                if ( value === '' ) {
                  updatedURL = resourcesString.replace(re, '$1' + '$2');
                } else {
                  updatedURL = resourcesString.replace(re, '$1' + name + "=" + value + '$2');
                }
            } else {
                if ( value === '' ) {
                  updatedURL = resourcesString;
              } else {
                  updatedURL = resourcesString + separator + name + "=" + value;
              }
            }
            resourcesString = updatedURL.replace('&&','&');
        };

    });

})(jQuery);
